module.exports = __webpack_public_path__ + "static/media/ball7.c3ff6293.png";